import React from 'react';
import { useTranslation } from 'react-i18next';
import usePlanFeatures from '../hooks/usePlanFeatures';

/**
 * Renders its children only when the center's package includes `feature`;
 * otherwise a short "not in your package" card (Basic has no WhatsApp).
 */
export default function PlanGate({ feature, children }) {
  const { t } = useTranslation();
  const features = usePlanFeatures();
  if (features[feature] !== false) return children;
  return (
    <div role="status" data-testid="plan-gate" style={{
      maxWidth: 560, margin: '3rem auto', padding: '2rem', textAlign: 'center',
      background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 16,
    }}>
      <h2 style={{ margin: '0 0 0.5rem', fontSize: '1.25rem' }}>{t('plans.notIncludedTitle')}</h2>
      <p style={{ margin: 0, color: 'var(--color-text-secondary)' }}>{t(`plans.notIncluded.${feature}`)}</p>
    </div>
  );
}
